const firebaseErrors: Partial<Record<string, string>> = {
	"auth/invalid-email": "Die eingegebene Email-Adresse ist ungültig.",
	"auth/invalid-login-credentials": "Die eingegebenen Anmeldedaten sind ungültig.",
	"auth/missing-password": "Bitte gebe ein Passwort ein.",
	"auth/user-disabled": "Dein Benutzerkonto ist aktuell deaktiviert.",
	"auth/email-already-in-use":
		"Die eingegebene Email-Adresse ist bereits mit einem Benutzerkonto verbunden. Bitte melde dich stattdessen an.",
	"auth/weak-password": "Bitte gebe ein Passwort mit mindestens 6 Zeichen ein.",
	"auth/too-many-requests":
		"Der Zugriff auf dieses Benutzerkonto wurde aufgrund zahlreicher fehlgeschlagener Anmeldeversuche vorübergehend deaktiviert.",
	"storage/unauthorized":
		"Das Hochladen ist aufgrund von Sicherheitsregeln nicht möglich. Wahrscheinlich existiert bereits eine Datei mit gleichem Namen.",
};

export default firebaseErrors;
